import QuizV1 from './QuizV1';
import QuizV3 from './QuizV3';
import QuizV4 from './QuizV4';

export default { QuizV1, QuizV3, QuizV4 };
